import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
function ServiceCategoryTypeViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.ServiceCategoryType())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
}
Bao.inherit(ServiceCategoryTypeViewModel, SearchPaging);
ServiceCategoryTypeViewModel.prototype.PrimaryKey = "ServiceCategoryTypeId";
ServiceCategoryTypeViewModel.prototype.RefreshUrl = "ServiceCategoryType/Get";
ServiceCategoryTypeViewModel.prototype.SaveUrl = "ServiceCategoryType/Save";
ServiceCategoryTypeViewModel.prototype.DeleteUrl = "ServiceCategoryType/Delete";
ServiceCategoryTypeViewModel.prototype.IsInUseUrl = "ServiceCategoryType/IsInUse";
ServiceCategoryTypeViewModel.prototype.PermissionForward = "ServiceCategoryTypeMoveForwardSearch";
ServiceCategoryTypeViewModel.prototype.PermissionBackward = "ServiceCategoryTypeMoveBackwardSearch";
ServiceCategoryTypeViewModel.prototype.PermissionSave = "ServiceCategoryTypeSave";
ServiceCategoryTypeViewModel.prototype.PermissionRefresh = "ServiceCategoryTypeRefresh";
ServiceCategoryTypeViewModel.prototype.PermissionDelete = "ServiceCategoryTypeDelete";
export default ServiceCategoryTypeViewModel;